export const generateMessageObject = (key: string) => ({
  id: key,
  defaultMessage: key,
});
